import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=50bf38ea&scoped=true&"
import script from "./Bubble.vue?vue&type=script&lang=ts&"
export * from "./Bubble.vue?vue&type=script&lang=ts&"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=50bf38ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf38ea",
  null
  
)

export default component.exports